/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { ChangeEvent } from 'react';
import { Input, InputAdornment } from '@mui/material';
import Close from '../../icons/Close.svg?react';
import Search from '../../icons/Search.svg?react';

const FilterInputStyle = css` 
  height: 40px;
  background: #ffffff;
`;

interface IProps {
  placeHolder: string;
  value: string | number;
  onChangeValue: (event: ChangeEvent<HTMLInputElement>) => void;
  onResetValue: () => void;
};

/**
 * @name FilterInput
 * @param props
 * @summary Controlled input for handling filters and search operations
 *
 */
const FilterInput = (props: IProps) => {
  const { placeHolder, value, onChangeValue, onResetValue } = props;
  return (
    <Input
      type="input"
      autoFocus
      onChange={onChangeValue}
      css={FilterInputStyle}
      disableUnderline={true}
      placeholder={placeHolder}
      value={value}
      startAdornment={
        <InputAdornment position="start">
          <Search />
        </InputAdornment>
      }
      endAdornment={
        value !== '' ? (
          <InputAdornment position="end" onClick={onResetValue}>
            <Close />
          </InputAdornment>
        ) : null
      }
    />
  );
};

export default FilterInput;
